import axios from 'axios'
import { safeErrorDigest } from '../utils/safeResponseMessage'

const origin = process.env.VUE_APP_API_ORIGIN
const responseData = response => response.data

/**
 * 応答本文が空のときだけ、利用者向けの文言を補う。
 *
 * <p>HTTPステータス番号は画面へ出さない。利用者が番号を見ても次の行動が
 * 決まらないうえ、サーバ側の事情がそのまま漏れる。調査に必要なので
 * コンソールには残す。</p>
 */
function withFallbackMessage (error) {
  const response = error && error.response
  if (!response || !response.status) return Promise.reject(error)

  console.error(`定期コメント通知の操作に失敗しました (${response.status})`, safeErrorDigest(error))
  if (!response.data) {
    response.data = {
      message: '定期コメント通知の設定を処理できませんでした。'
        + 'しばらく経ってからもう一度お試しください。'
    }
  }
  return Promise.reject(error)
}

export default {
  get (projectId) {
    return axios
      .get(`${origin}/project-notifications/${projectId}/periodic`)
      .then(responseData)
      .catch(withFallbackMessage)
  },
  update (projectId, payload) {
    return axios
      .post(`${origin}/project-notifications/${projectId}/periodic`, payload)
      .then(responseData)
      .catch(withFallbackMessage)
  },
  test (projectId, scheduleCode, payload) {
    return axios
      .post(
        `${origin}/project-notifications/${projectId}/periodic/${scheduleCode}/test`,
        payload
      )
      .then(responseData)
      .catch(withFallbackMessage)
  }
}
